import { isBrowser } from '../helpers'
import { query, saveUser } from './utilities'
import { API_URL } from '../constants/config'

export const getUser = () =>
  isBrowser() && window.localStorage && window.localStorage.getItem('mmsgUser')
    ? JSON.parse(window.localStorage.getItem('mmsgUser'))
    : {}

export const isLoggedIn = () => {
  const user = getUser()
  return !!user.token
}

export const logout = () => {
  localStorage.removeItem('mmsgUser')
}

export const validateAccessCode = (opportunityId, accessCode, token) =>
  query(`${API_URL}/Auth/${global.config.brand}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ opportunityId, accessCode, token }),
  }).then((user) => {
    if (user.token) {
      const result = {
        token: user.token,
        opportunityId,
        expiresIn: user.expiresIn,
        isAtSettlement: user.isAtSettlement,
      }
      saveUser(result) //save token in local storage
      return result
    } else {
      return Promise.reject('bad response token')
    }
  })

export const requestAccessCode = (
  opportunityId,
  authenticationMethod,
  token
) => {
  var inputDetails = {
    token: token,
  }
  return query(
    `${API_URL}/Auth/${opportunityId}/${authenticationMethod}/${global.config.brand}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inputDetails),
    }
  )
}
